// import matter from "gray-matter";

// export const loadBlog = async (slug) => {
//   const file = await fetch(`/blogs/${slug}.md`);
//   const text = await file.text();
//   const { metadata, content } = parseMarkdown(text);

//   const preview = content.split("\n")[0];

//   return {
//     slug,
//     ...metadata,
//     content,
//     preview: extractPreview(content),
//     readingTime: calculateReadingTime(content),
//   };
// };

// const extractPreview = (markdown) => {
//   return markdown
//     .replace(/[#>*]/g, "")
//     .replace(/\n/g, " ")
//     .trim()
//     .substring(0, 180);
// };

// const parseMarkdown = (text) => {
//   const parts = text.split("---");

//   let metadata = {};
//   let content = text;

//   if (parts.length > 2) {
//     const metaLines = parts[1].trim().split("\n");

//     metaLines.forEach((line) => {
//       const [key, ...rest] = line.split(":");
//       metadata[key.trim()] = rest.join(":").trim();
//     });

//     content = parts.slice(2).join("---");
//   }

//   return { metadata, content };
// };

// const calculateReadingTime = (text) => {
//   const words = text.split(/\s+/).length;
//   return Math.ceil(words / 200) + " min read";
// };

// export const getBlogBySlug = async (slug) => {
//   const file = await fetch(`/blogs/${slug}.md`);
//   const text = await file.text();

//   const { metadata, content } = parseMarkdown(text);

//   return {
//     slug,
//     ...metadata,
//     content,
//     readingTime: calculateReadingTime(content),
//   };
// };

// export const getAllBlogs = async () => {
//   const indexRes = await fetch("/blogs/index.json");
//   const slugs = await indexRes.json();

//   const blogs = await Promise.all(
//     slugs.map(async (slug) => {
//       const res = await fetch(`/blogs/${slug}.md`);
//       const text = await res.text();

//       const parts = text.split("---");

//       let metadata = {};
//       let content = "";

//       if (parts.length > 2) {
//         const metaLines = parts[1].trim().split("\n");

//         metaLines.forEach((line) => {
//           const [key, ...rest] = line.split(":");
//           metadata[key.trim()] = rest.join(":").trim();
//         });

//         content = parts.slice(2).join("---");
//       }

//       return {
//         slug,
//         ...metadata,
//         content,
//         preview: extractPreview(content),
//         readingTime: calculateReadingTime(content),
//       };
//     }),
//   );

//   return blogs;
// };

// utils/loadBlogs.js

import api from "./api";

// const API_BASE = import.meta.env.VITE_API_BASE_URL; // e.g. https://yourapi.com/api

const calculateReadingTime = (text = "") => {
  const words = text.split(/\s+/).length;
  return Math.ceil(words / 200) + " min read";
};

const extractPreview = (markdown = "") => {
  return markdown
    .replace(/[#>*]/g, "")
    .replace(/\n/g, " ")
    .trim()
    .substring(0, 180);
};

// Normalize DB blog → shape your components expect
const normalizeBlog = (blog) => ({
  ...blog,
  slug: blog.slug || blog._id,
  date: blog.publishedAt || blog.createdAt,
  preview: blog.excerpt || extractPreview(blog.content),
  readingTime: calculateReadingTime(blog.content),
  coverImage: blog.coverImage || null,
});

// export const getAllBlogs = async () => {
//   const { data } = await api.get("/blog/public?limit=100");
//   return (data.blogs || []).map(normalizeBlog);
// };

export const getAllBlogs = async () => {
  try {
    const { data } = await api.get("/blog/public?limit=100");
    return (data.blogs || []).map(normalizeBlog);
  } catch (error) {
    console.error(
      "Failed loading blogs:",
      error.response?.data || error.message,
    );

    return [];
  }
};

export const getBlogBySlug = async (slug) => {
  const { data } = await api.get(`/blog/public/${slug}`);
  return normalizeBlog(data.blog);
};
